import cRequest, { clearAccessToken } from "@services/c-request"
import { initialState } from "@services/global-slice"
import { encrypt } from "../helpers"

interface SignUpProps {
  email: string
  password: string
  firstname: string
  phone: string
}
interface FetchProfileProps {
  key: string
  value: string
  includeSensitive?: boolean
}

const urlSignupPath = `${process.env.REACT_APP_BASE_URL}/auth/signup`
const urlVerifyEmailPath = `${process.env.REACT_APP_BASE_URL}/auth/verify-email`
const profilePath = `${process.env.REACT_APP_BASE_URL}/profile`
const authPath = `${process.env.REACT_APP_BASE_URL}/auth`

// verify email
export const verifyEmailService = async (values: SignUpProps) => {
  return cRequest
    .post(urlVerifyEmailPath, values)
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

// sign up
export const signUpService = async (values: SignUpProps) => {
  return cRequest
    .post(urlSignupPath, values)
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

// profile

export const fetchProfileService = async (values: FetchProfileProps) => {
  const { key, value, includeSensitive } = values
  return cRequest
    .post(`${profilePath}/fetch-profile`, { key, value, includeSensitive })
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const searchProfilesByEmailService = async (email: string) => {
  return cRequest
    .get(`${profilePath}/search-profiles-by-email`, { params: { email } })
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const getAllProfilesService = async () => {
  return cRequest
    .get(`${profilePath}/get-all-profiles`)
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const updateProfileService = async (body: any) => {
  const { data, uid, email } = body
  return cRequest
    .put(`${profilePath}/update-profile`, { data, uid, email })
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const updatePasswordService = async (body: any) => {
  const { email, currentPassword, newPassword, verifyCurrentPassword } = body
  return cRequest
    .put(`${profilePath}/update-password`, {
      email,
      currentPassword,
      newPassword,
      verifyCurrentPassword,
    })
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}

export const isAuthorizedService = async () => {
  return cRequest
    .get(`${authPath}/auth-state`, {})
    .then(function (response: any) {
      if (response?.data) {
        return response.data
      } else {
        return initialState.user
      }
    })
    .catch(function (error: any) {
      // console.log(error)
      return initialState.user
    })
}

export const signOutService = async () => {
  clearAccessToken()
  return cRequest
    .post(`${authPath}/logout`)
    .then(function (response: any) {
      return initialState.user
    })
    .catch(function (error: any) {
      console.log(error)
      return initialState.user
      // throw error
    })
}

export const signInService = async (body: any) => {
  const { email, password, hashed } = body

  let values
  if (hashed === true) {
    values = {
      username: email,
      password: JSON.stringify({ hashed: encrypt(password) }),
    }
  } else {
    values = {
      username: email,
      password: JSON.stringify({ plain: encrypt(password) }),
    }
  }

  return cRequest
    .post(`${authPath}/login`, values)
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      // throw error
    })
}

export const googleSignInService = async (body: any) => {
  return cRequest
    .get(`${authPath}/google-oauth-verify`, body)
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      // throw error
    })
}

export const verifyResetTokenService = async (token: string) => {
  return cRequest
    .post(`${profilePath}/verify-reset-token`, { token })
    .then(function (response: any) {
      return response
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}
